import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { Application } from '../../../pages/user-manager/tab-applications/application.types';

export const APP_TYPE = Application.MEMBER_MANAGER;
export const APPLICATION_TYPE_HEADER = 'X-Application-Type';

export const headerInterceptor: HttpInterceptorFn = (req, next) => {
    if (req.url.startsWith(environment.CORE_SVC_AUTH_URL)) {
        return next(req);
    }

    if (!req.headers.has(APPLICATION_TYPE_HEADER)) {
        const modifiedReq = req.clone({
            headers: req.headers.set(APPLICATION_TYPE_HEADER, APP_TYPE),
        });
        return next(modifiedReq);
    }

    return next(req);
};
